import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { CacheService } from '../../services/cache/cache.service';
import { CommonService } from '../../services/common/common.service';
import { Column } from '../interfaces/column.interface';
import moment from 'moment';
import { User, UsersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class QuizzesColumnsService {

  public users: User[] = [];
  public kindsOptions = [{
    value: 'SingleChoice',
    label: 'KINDSSINGLECHOICE',
    css: 'primary'
  }, {
    value: 'MultipleChoice',
    label: 'KINDSMULTIPLECHOICE',
    css: 'success'
  }];
  public statusesOptions = [{
    value: 'Draft',
    label: 'STATUSESDRAFT',
    css: 'primary'
  }, {
    value: 'Online',
    label: 'STATUSESONLINE',
    css: 'success'
  }, {
    value: 'Deactivated',
    label: 'STATUSESDEACTIVATED',
    css: 'warning'
  }, {
    value: 'Offline',
    label: 'STATUSESOFFLINE',
    css: 'danger'
  }, {
    value: 'Deleted',
    label: 'STATUSESDELETED',
    css: 'default'
  }, {
    value: 'Archived',
    label: 'STATUSESARCHIVED',
    css: 'info'
  }];

  public levelsOptions = [{ 
    value: 'Beginner',
    label: 'Beginner',
    css: 'primary'
  }, {
    value: 'Intermediate',
    label: 'Intermediate',
    css: 'success'
  }, {
    value: 'Expert',
    label: 'Expert',
    css: 'warning'
  }];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private cache: CacheService,
    private common: CommonService,

  ) {
  }





  getColumns(): Column[] {
    return [
      { field: 'id', sortField: 'id', title: this.translate.instant('ID'), show: (this.navigation.getParamValue('quizzes.id.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'picture', sortField: 'picture', title: this.translate.instant('PICTURE'), show: (this.navigation.getParamValue('quizzes.picture.showFiled', false) && true), displayInList: true, type: 'imgValue'},
      { field: 'description', sortField: 'description', title: this.translate.instant('DESCRIPTION'), show: (this.navigation.getParamValue('quizzes.description.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'descriptionAr', sortField: 'descriptionAr', title: this.translate.instant('DESCRIPTIONAR'), show: (this.navigation.getParamValue('quizzes.descriptionAr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'descriptionFr', sortField: 'descriptionFr', title: this.translate.instant('DESCRIPTIONFR'), show: (this.navigation.getParamValue('quizzes.descriptionFr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'kind', sortField: 'kind', title: this.translate.instant('KIND'), show: (this.navigation.getParamValue('quizzes.kind.showFiled', false) && true), displayInList: true, type: 'enumValue', filterData: this.kindsOptions},
      { field: 'question', sortField: 'question', title: this.translate.instant('QUESTION'), show: (this.navigation.getParamValue('quizzes.question.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice1', sortField: 'choice1', title: this.translate.instant('CHOICE1'), show: (this.navigation.getParamValue('quizzes.choice1.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice1Fr', sortField: 'choice1Fr', title: this.translate.instant('CHOICE1FR'), show: (this.navigation.getParamValue('quizzes.choice1Fr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice1IsCorrect', sortField: 'choice1IsCorrect', title: this.translate.instant('CHOICE1ISCORRECT'), show: (this.navigation.getParamValue('quizzes.choice1IsCorrect.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'choice2', sortField: 'choice2', title: this.translate.instant('CHOICE2'), show: (this.navigation.getParamValue('quizzes.choice2.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice2Fr', sortField: 'choice2Fr', title: this.translate.instant('CHOICE2FR'), show: (this.navigation.getParamValue('quizzes.choice2Fr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice2IsCorrect', sortField: 'choice2IsCorrect', title: this.translate.instant('CHOICE2ISCORRECT'), show: (this.navigation.getParamValue('quizzes.choice2IsCorrect.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'choice3', sortField: 'choice3', title: this.translate.instant('CHOICE3'), show: (this.navigation.getParamValue('quizzes.choice3.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice3Fr', sortField: 'choice3Fr', title: this.translate.instant('CHOICE3FR'), show: (this.navigation.getParamValue('quizzes.choice3Fr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice3IsCorrect', sortField: 'choice3IsCorrect', title: this.translate.instant('CHOICE3ISCORRECT'), show: (this.navigation.getParamValue('quizzes.choice3IsCorrect.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'choice4', sortField: 'choice4', title: this.translate.instant('CHOICE4'), show: (this.navigation.getParamValue('quizzes.choice4.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice4Fr', sortField: 'choice4Fr', title: this.translate.instant('CHOICE4FR'), show: (this.navigation.getParamValue('quizzes.choice4Fr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'choice4IsCorrect', sortField: 'choice4IsCorrect', title: this.translate.instant('CHOICE4ISCORRECT'), show: (this.navigation.getParamValue('quizzes.choice4IsCorrect.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'status', sortField: 'status', title: this.translate.instant('STATUS'), show: (this.navigation.getParamValue('quizzes.status.showFiled', false) ),  displayInList: true, type: 'enumValue', filterData: this.statusesOptions},

      { field: 'level', sortField: 'level', title: this.translate.instant('level'), show: (this.navigation.getParamValue('quizzes.level.showFiled', false) ),  displayInList: true, type: 'enumValue', filterData: this.levelsOptions},


      { field: 'createdAt', sortField: 'createdAt', title: this.translate.instant('CREATEDAT'), show: (this.navigation.getParamValue('quizzes.createdAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'modifiedAt', sortField: 'modifiedAt', title: this.translate.instant('MODIFIEDAT'), show: (this.navigation.getParamValue('quizzes.modifiedAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'actions', title: this.translate.instant('ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null},
    ];
  }

  format(fieldName: string, value: any) {
    if (fieldName.toLowerCase().indexOf('time') > -1) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else if (fieldName.toLowerCase().indexOf('date') > -1) {
      return moment(value).format('YYYY-MM-DD');
    }
    return value;
  }

}
